(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const main = document.querySelector('main#MainContent');
  if (!main || main.dataset.template !== 'index') return;

  const targets = main.querySelectorAll('.shopify-section');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal-visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach((target) => {
    target.classList.add('scroll-reveal-init');
    observer.observe(target);
  });
})();
